import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Alert } from 'src/app/shared/class/Alert';
import { Table } from 'src/app/shared/models/table.model';
import { UpdateDatabaseService } from '../../update-database.service';

@Component({
  selector: 'app-update-database-list',
  templateUrl: './update-database-list.component.html',
  styleUrls: ['./update-database-list.component.scss']
})
export class UpdateDatabaseListComponent implements OnInit {
  goback = '';
  subscription = new Subscription();
  displayedColumns: string[] = ['id', 'name', 'updated', 'update'];
  dataSource: MatTableDataSource<Table>;
  tables: Table[] = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private updateDatabaseService: UpdateDatabaseService,
    private spinner: NgxSpinnerService
  ) {

  }

  async ngOnInit() {
    await this.reloadTable();
  }

  async reloadTable() {
    try {
      this.spinner.show();
      const data: any = await this.updateDatabaseService.getTables();
      this.tables = (data.status === undefined) ? data : [];
      this.dataSource = new MatTableDataSource(this.tables);

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error(error);
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  updateTable(endpoint) {
    this.spinner.show();
    this.subscription.add(this.updateDatabaseService.updateTable(endpoint).subscribe(
      () => {
        this.spinner.hide();
        Alert.success(Alert.getMessage().success.updateTable).then(() => this.reloadTable());
      },
      () => {
        this.spinner.hide();
        Alert.error(Alert.getMessage().errors.updateTable);
      }
    ));
  }


}
